import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AofMenuItem } from '../aof-menu/aof-menu.component';
import { mainMenu } from '../main-menu';

@Injectable({
    providedIn: 'root'
})
export class AofMenuService {
    // Başlangıçta ana menü ile başlatıyoruz
    private menuItemsMethod = new ReplaySubject<AofMenuItem[]>(1);
    public menuItems$ = this.menuItemsMethod.asObservable();

    constructor() {
        this.clearMenu();
    }

    /**
     * Aktif menü öğelerini günceller.
     * Her modül kendi layout component'inde bunu çağırarak menüyü değiştirebilir.
     */
    setMenuItems(items: AofMenuItem[]) {
        // NG0100: ExpressionChangedAfterItHasBeenCheckedError hatasını önlemek için 
        // güncellemeyi bir sonraki micro-task'a erteliyoruz.
        Promise.resolve().then(() => {
            this.menuItemsMethod.next(items);
        });
    }

    /**
     * Menüyü varsayılan ana menüye çeker.
     */
    clearMenu() {
        Promise.resolve().then(() => {
            this.menuItemsMethod.next(mainMenu);
        });
    }
}
